import React from "react";
import { connect } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import navigationConfig from "configs/NavigationConfig";
import { getResolvedUserType } from "utils/MyMUtils";
import { findActiveNavEntry, isTopLevelNavVisible, pathMatches } from "utils/navUtils";

export const ModuleHeader = ({ isSuperAdmin }) => {
  const { pathname } = useLocation();
  const entry = findActiveNavEntry(navigationConfig, pathname);

  if (!entry) {
    return null;
  }

  // Sub-page tabs (Admin, Workforce) are navigation, so they follow the same
  // visibility rules as the sidebar; a module's own tabs (tabKey) are part of
  // the page and show for whoever is on it. The title always shows.
  const canNavigate = isTopLevelNavVisible(entry, isSuperAdmin, getResolvedUserType());
  const tabs = (entry.submenu || []).filter((sub) => sub.path && (canNavigate || sub.tabKey));

  return (
    <div className="module-header">
      <div>
        <h1 className="module-header-title">{entry.title}</h1>
        {entry.description ? <div className="module-header-desc">{entry.description}</div> : null}
      </div>
      {tabs.length > 1 ? (
        <nav className="module-tabs">
          {tabs.map((sub) => {
            const active = pathMatches(sub.path, pathname);
            return (
              <Link
                key={sub.key}
                to={sub.path}
                className={`module-tab${active ? " active" : ""}`}
                // set apart at the right end of the bar (inline: the theme's
                // stylesheet is pre-compiled)
                style={sub.end ? { marginLeft: "auto" } : undefined}
                aria-current={active ? "page" : undefined}
              >
                {sub.end && sub.icon ? <sub.icon style={{ marginRight: 6 }} /> : null}
                {sub.title}
              </Link>
            );
          })}
        </nav>
      ) : null}
    </div>
  );
};

const mapStateToProps = ({ userAuth }) => ({ isSuperAdmin: Number(userAuth?.isSuperAdmin) === 1 });

export default connect(mapStateToProps)(ModuleHeader);
